"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleTemplate = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const entity_type_1 = require("./entity-type");
const flags_1 = require("./flags");
const handlers_1 = require("./handlers");
exports.ScheduleTemplate = typebox_1.Type.Object({
    handler: handlers_1.Handler,
    template: typebox_1.Type.String(),
    sendAs: typebox_1.Type.Optional(typebox_1.Type.String()),
    destination: typebox_1.Type.String(),
    templateData: typebox_1.Type.Optional(typebox_1.Type.Unknown()),
    sendAfter: typebox_1.Type.String({ format: 'date-time' }),
    notifySenderOnFail: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    topic: typebox_1.Type.String(),
    flags: typebox_1.Type.Optional(typebox_1.Type.Array(flags_1.NotificationFlag)),
    directAttachments: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        content: typebox_1.Type.String(),
        type: typebox_1.Type.String(),
        filename: typebox_1.Type.String(),
        disposition: typebox_1.Type.String(),
    }))),
    attachmentS3ItemRefs: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    references: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
        entityType: entity_type_1.EntityType,
        id: typebox_1.Type.String(),
    }))),
});
//# sourceMappingURL=schedule-template.js.map